const company = () => import('@/views/main/order/company/company.vue')
export default {
  path: '/main/order/company',
  name: 'company',
  component: company,
  children: []
}
